<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">A</span><span class="ePub-SC-B1">CKNOWLEDGMENTS</span></span></p>
<p class="FMTNI">Everyone should have a friend like Fran McClain. Not only does she lend me prized cookbooks and handwritten recipes, but she also hosted a German Oktoberfest for me in July so I could sample sauerbraten and spaetzle. And to Greg, my son, who truly gets what it’s like to be a writer—and lets me know he’s proud of me. Have I told my friends in the Purple Gang and Sweet T’s how much I appreciate you welcoming me back into the fold after lengthy absences while I’ve been in the “basement” writing? If not, forgive me. I treasure your friendships. No less appreciated is my husband, Bob, who never complains about egg sandwiches for dinner. My acknowledgments wouldn’t be complete without a shout-out to the wonderful readers who love nothing more than to curl up with a cozy. May that addiction never end.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?00a83ed6